import React from "react";
import { FileText } from "lucide-react";
import InputLine from "~/components/RegisterForm/InputLine";
import InputLineGroup from "~/components/RegisterForm/InputLineGroup";
import SelectPopover from "~/components/RegisterForm/SelectPopover";
import FindGeneric from "~/components/Finds/FindGeneric";
import FileInput from "~/components/RegisterForm/FileInput";
import { monthOptions, yearOptions } from "../monthOptions";

export default function ImportForm({
  InputContext,
  activeMenu,
  monthData,
  onAccountSelected,
}) {
  const lockedAccount = !!monthData?.bankAccount?.id;
  const now = new Date();

  return (
    <InputLineGroup title="GENERAL" activeMenu={activeMenu}>
      <FindGeneric
        route="bankaccounts"
        title="Bank Account"
        scope="bankAccount"
        required
        InputContext={InputContext}
        readOnly={lockedAccount}
        setReturnFindGeneric={onAccountSelected}
        defaultValue={{
          id: monthData?.bankAccount?.id,
          account: monthData?.bankAccount?.account,
          bank: monthData?.bankAccount?.bank,
        }}
        fields={[
          {
            title: "Account",
            name: "account",
          },
          {
            title: "Bank",
            model: "bank",
            name: "bank_name",
          },
        ]}
      />

      <InputLine title="Period">
        <SelectPopover
          name="month"
          title="Month"
          grow
          required
          readOnly={lockedAccount}
          options={monthOptions}
          defaultValue={
            monthData?.month
              ? monthOptions[Number(monthData.month) - 1]
              : monthOptions[now.getMonth()]
          }
          InputContext={InputContext}
        />
        <SelectPopover
          name="year"
          title="Year"
          grow
          required
          readOnly={lockedAccount}
          options={yearOptions}
          defaultValue={
            monthData?.year
              ? yearOptions.find(
                  (option) => option.value === Number(monthData.year)
                )
              : yearOptions.find((option) => option.value === now.getFullYear())
          }
          InputContext={InputContext}
        />
      </InputLine>

      <InputLine title="Statement File">
        <FileInput
          name="import_file"
          title="File"
          grow
          required
          InputContext={InputContext}
          fields={[{ title: "Name", name: "name" }]}
        />
      </InputLine>

      {monthData?.statements?.length ? (
        <InputLine title="Imported Statements">
          <div className="w-full flex flex-col gap-1 pt-2 text-xs">
            {monthData.statements.map((statement) => (
              <div
                key={statement.id}
                className="flex flex-row items-center gap-2 text-gray-600"
              >
                <FileText size={14} />
                <span>
                  {statement.date_from} to {statement.date_to}
                </span>
                <span className="text-gray-400">
                  {statement.total_items ?? 0} movements
                </span>
              </div>
            ))}
          </div>
        </InputLine>
      ) : null}
    </InputLineGroup>
  );
}
